module.exports = __webpack_public_path__ + "static/media/knight.68459b26.svg";